import { create } from 'zustand';

interface LastViewedSubmissionState {
  lastViewedSubmissionId: number | null;
  setLastViewedSubmissionId: (submissionId: number) => void;
}

export const useLastViewedSubmissionStore = create<LastViewedSubmissionState>((set) => ({
  lastViewedSubmissionId: null,
  setLastViewedSubmissionId: (submissionId) => set({ lastViewedSubmissionId: submissionId }),
}));
